
<kendo-pdf-export class="kendoFlex" #pdfPrint [keepTogether]="keepTogether">
    <ng-content></ng-content>
</kendo-pdf-export>
    